import Rest from '../rest'

/******************************************************************************
 * Product Availability
 *****************************************************************************/

/**
 * @type {Availability}
 */
export default class Availability extends Rest {

    constructor () {
        super('/productAvailability')
    }

    /**
     * Sobreescrita do método get da V2, pois o resource da V2 é availability e não
     * productAvailability
     *
     * @param {String} url 
     * @param {String|Number} id 
     * @param {Object} params 
     * @param {Object} config 
     * @returns 
     */
    getV2(url, id, params, config = {}) {
        return this.http2.get(
            this.constructor.normalize(this.constructor.normalize('availability', url), id),
            {
                params,
                ...config
            }
        ).then(response => {
            if (response.data && response.data.status === 'error') return Promise.reject(response)

            return response
        })
    }

    /**
     * Busca as torres/quadras de acordo com o ID de uma disponibilidade
     *
     * @param {String|Number} id ID da disponibilidade
     * @returns 
     */
    getBlocks(id) {
        return this.http.get(
            this.constructor.normalize(this.constructor.normalize('availability', id), 'blocks')
        ).then(response => {
            if (response.data && response.data.status === 'error') return Promise.reject(response)

            return response
        })
    }

    /**
     * Busca as torres/quadras de acordo com o ID de uma disponibilidade utilizando a API V2
     *
     * @param {String|Number} id ID da disponibilidade
     * @returns 
     */
    getBlocksV2(id) {
        return this.http2.get(
            this.constructor.normalize(this.constructor.normalize('availability', id), 'blocks')
        ).then(response => {
            if (response.data && response.data.status === 'error') return Promise.reject(response)

            return response
        })
    }

    /**
     * Busca as unidades de acordo com uma disponibilidade de produto e uma quadra/torre
     *
     * @param {String|Number} availabilityId ID da disponibilidade
     * @param {*} blockId ID da quadra/torre em questão
     * @returns 
     */
    getBlockUnits(availabilityId, blockId) {
        return this.http.get(
            this.constructor.normalize(
                this.constructor.normalize(
                    this.constructor.normalize('availability', availabilityId),
                    'block'
                ),
                blockId
            )
        ).then(response => {
            if (response.data && response.data.status === 'error') return Promise.reject(response)

            return response
        })
    }
  
}